export const getExtraDOMAttributes = (attributes) => {
  const { currentAddress, locations, zoomLevel } = attributes;
  const attrs = {
    "data-current-address": currentAddress,
    "data-zoom-level": zoomLevel,
  };
  // Only emit data-locations when non-empty to avoid breaking existing saved blocks
  if (locations && locations.length > 0) {
    attrs["data-locations"] = JSON.stringify(locations);
  }
  return attrs;
};
